import { createPlanNameMatcher, getKeyDetailsContentIcon } from './utils/PlanMetaHelper';
import { DETAILS_CONTENT_KEYS, IPlanContent } from '../typings/planContent.types';
import { PlanKeyDetailsModal } from './common/PlanKeyDetailsModal';
import { CONTENT_SEPARATOR, PLAN_DETAILS_PLAN_PERIOD_BENEFIT } from '../typings';
import {
  defaultEstimatesDialog,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
  gasKeyDetailsAddons,
} from './common/planDefaults';
import { EmployeeInternetOfferPerk } from './common/internetOfferPerk';

export const employeeGoKeyDetails = [
  {
    contentKey: DETAILS_CONTENT_KEYS.Rates,
    contentValue: 'Variable',
    modalContent: PlanKeyDetailsModal,
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Rates),
    contentDescription: 'Variable rates',
  },
  {
    contentKey: DETAILS_CONTENT_KEYS.ExitFees,
    contentValue: 'No',
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.ExitFees),
    contentDescription: 'No exit fees. Leave anytime.',
  },
  {
    contentKey: DETAILS_CONTENT_KEYS.BenefitPeriod,
    contentValue: '12 months' + CONTENT_SEPARATOR + PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BenefitPeriod),
    contentDescription: '12 month benefit period',
  },
];

export const employeeGoContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Employee Go Variable']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on a 12 month benefit period',
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: employeeGoKeyDetails,
        gas: employeeGoKeyDetails,
        electricity: employeeGoKeyDetails,
        dual: employeeGoKeyDetails,
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        dual: dualKeyDetailsAddons,
        gas: gasKeyDetailsAddons,
        electricity: electricityKeyDetailsAddons,
      },
    },
    keyFeatures: {
      defaultState: {
        defaultFuel: ['12 months', 'No lock-in contracts, leave anytime'],
      },
    },
    perkAccordion: {
      defaultState: {
        dual: [EmployeeInternetOfferPerk],
        gas: [EmployeeInternetOfferPerk],
        electricity: [EmployeeInternetOfferPerk],
        defaultFuel: [],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'grey',
              odsCore: 'neutral',
            },
            promobox: {
              styleGuide: 'lightOrange',
              odsCore: 'caution',
            },
            bannerText: {
              styleGuide: 'grey56',
              odsCore: 'neutralDark',
            },
          },
          imageUrl:
            'https://res.cloudinary.com/originenergy/image/upload/v1728625530/spot-illustrations/spot_house.svg',
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-go-variable.svg',
            gas: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-go-variable.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-go-variable.svg',
          },
        },
      },
    },
    tagLine: {
      defaultState: { defaultFuel: 'Rates variable on a 12 month energy plan' },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/origin-go.html',
      },
    },
    estimatesDialog: defaultEstimatesDialog(),
  },
};
